import { TEST_AVAILABILITY_ENDPOINT } from 'MeetingsLib/constants/endpoints';
import { hubletAwareApi } from 'MeetingsLib/utils/utils';
/**
 * @deprecated do not use this request - endpoint no longer exists
 */
export function postAllAvailability(httpClient, data) {
  return httpClient.post(TEST_AVAILABILITY_ENDPOINT, {
    api: hubletAwareApi,
    withCredentials: false,
    data
  });
}